import React from "react";
import { Link } from "react-router";
import {
  Drawer,
  Layout,
  Avatar,
  Popover,
  Menu,
  Modal,
  Image,
  Tag,
  Statistic,
  Space,
  Tooltip,
  Divider,
} from "antd";
import {
  DownloadOutlined,
  FilePdfOutlined,
  LogoutOutlined,
  PauseOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import CustomScrollbars from "../../utils/CustomScrollbars";
import messages from "../../messages";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from "react-sortable-hoc";
import { createPreviewImgSrc } from "../../utils/utils";

const { Sider } = Layout;
const MenuItemGroup = Menu.ItemGroup;

const SidebarLogo = () => {
  return (
    <div className="gx-layout-sider-header">
      <Link to="/" className="gx-site-logo">
        <img alt="lo" src={"images/touchit-logo.png"} />
      </Link>
    </div>
  );
};

const DragHandle = SortableHandle(({ slide }) => (
  <Image
    src={createPreviewImgSrc(slide.path)}
    style={{ minHeight: 100, maxHeight: 180 }}
    onError={(e) => {
      e.target.onerror = null;
      e.target.src = slide.thumbnail;
    }}
    fallback="data:image/png;base64,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"
    className="gx-rounded-lg"
  />
));

const SortableItem = SortableElement(
  ({ count, item, removeSlide, previewSlide }) => (
    <li style={{ zIndex: 10 }} className="gx-module-nav-label">
      <div className="gx-profileon gx-pointer gx-border">
        <div className="gx-profileon-thumb gx-text-center">
          <DragHandle slide={item} />
        </div>
        <div className="gx-profileon-content">
          <Tag color={"#02a2de"} className="gx-mb-1 gx-text-truncate">
            {item.name}
          </Tag>
        </div>
      </div>
    </li>
  )
);

const SortableList = SortableContainer(
  ({ setRef, items, removeSlide, previewSlide, addWhiteBoardToWorkbook }) => (
    <ul className="gx-module-nav">
      {items.map((item, index) => (
        <SortableItem
          key={`item-${index}`}
          index={index}
          item={item}
          removeSlide={removeSlide}
          count={index}
          previewSlide={previewSlide}
        />
      ))}
    </ul>
  )
);

const Sidebar = ({
  visible,
  toggleSlidePreview,
  slides,
  removeSlide,
  previewSlide,
  onSortEnd,
  pauseStudentScreen,
  togglePdfNameAlert,
  toggleStudentNavigation,
}) => {
  return (
    <Sider
      className={`gx-app-sidebar gx-collapsed-sidebar`}
      trigger={null}
      collapsed={false}
      collapsible
    >
      <Drawer
        className={`gx-drawer-sidebar`}
        placement="right"
        closable={true}
        onClose={toggleSlidePreview}
        visible={visible}
      >
        <SidebarLogo />
        <div className="gx-sidebar-content">
          {/* <div className={`gx-sidebar-notifications`}>
            <div className="gx-flex-column gx-align-items-center gx-mb-4 gx-avatar-row">
              <div className="gx-linebar">
                <Space>
                  <Tooltip title={"Pause Lecture"}>
                    <PauseOutlined
                      onClick={pauseStudentScreen}
                      className="gx-icon-btn icon"
                    />
                  </Tooltip>

                  <Tooltip title={"Hide Navigation"}>
                    <StopOutlined
                      onClick={toggleStudentNavigation}
                      className="gx-icon-btn icon"
                    />
                  </Tooltip>

                  <Tooltip title={"Download Lecture As PDF"}>
                    <FilePdfOutlined
                      onClick={togglePdfNameAlert}
                      className="gx-icon-btn icon"
                    />
                  </Tooltip>
                </Space>
              </div>
            </div>
          </div> */}

          <CustomScrollbars className="gx-layout-sider-scrollbar">
            <SortableList
              removeSlide={removeSlide}
              previewSlide={previewSlide}
              items={slides}
              onSortEnd={onSortEnd}
              useDragHandle={true}
            />
          </CustomScrollbars>
        </div>
      </Drawer>
    </Sider>
  );
};

export default Sidebar;
